import React from 'react';
import WelcomeSection from './components/WelcomeSection';
import CadastroForm from './components/CadastroForm';

const CadastroClientesPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-orange-50/30">
      <WelcomeSection />
      <div className="py-20 relative">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-20 left-10 w-72 h-72 bg-gradient-to-r from-orange-400 to-red-400 rounded-full mix-blend-multiply filter blur-xl animate-pulse"></div>
          <div className="absolute top-40 right-10 w-72 h-72 bg-gradient-to-r from-red-400 to-pink-400 rounded-full mix-blend-multiply filter blur-xl animate-pulse delay-1000"></div>
          <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-gradient-to-r from-orange-300 to-yellow-400 rounded-full mix-blend-multiply filter blur-xl animate-pulse delay-2000"></div>
        </div>
        
        <div className="container relative z-10">
          <div className="max-w-5xl mx-auto">
            <CadastroForm />
          </div>
        </div>
      </div>
      
      {/* Footer Section */}
      <div className="bg-gradient-to-r from-slate-900 via-orange-900 to-red-900 py-12">
        <div className="container">
          <div className="text-center text-white">
            <div className="flex justify-center mb-6">
              <img 
                src="https://static.readdy.ai/image/60d079db6e314477a5615b4d3efd8435/1aa70460cb4235142615a402493549d1.png" 
                alt="M4 Digital" 
                className="h-10 w-auto opacity-80"
              />
            </div>
            <p className="text-gray-300 mb-4">
              Transformando empresas através da inteligência artificial e automação comercial
            </p>
            <div className="flex justify-center space-x-6 text-sm text-gray-400">
              <span>© 2026 M4 Digital</span>
              <span>•</span>
              <span>Todos os direitos reservados</span>
              <span>•</span>
              <span>São Bernardo do Campo - SP</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CadastroClientesPage;
